<template>
  <ul class="menu_line">
    <menu-item v-for="(item, index) in enabledItems" 
      :key="index" 
      :roles="item.roles" 
      :icon="item.icon" 
      :fontAwesomeIcon="item.faIcon" 
      :title="$t(item.i18nTitle)" 
      :link="item.to" >
    </menu-item>
  </ul>
</template>
<script>

import menuItem from "./menu-item.vue"
import featureFlagsService from '@/app/shared/services/featureFlagsService.js'

export default {
  name: "menu-control",
  components: {
    menuItem
  },
  props: {
    items: Array
  },
  computed: {
    enabledItems() {
      return this.items.filter(item => featureFlagsService.isEnabled(item.featureFlag))
    }
  }
};
</script>

<style lang="scss">

.menu_line {
  margin-left: 3.5rem;
  padding-left: 40px;
  border-left: 2px solid #E5E8EB;

  li {
    position: relative;
    margin-bottom: 40px;

    .menu-icon {
      position: absolute;
      top: 0;
      left: -4.3rem;
      border-radius: 50%;
      padding: .75rem;
      padding-bottom: 0.4rem;
    }

    .activity-desc {
      font-size: .9rem;
    }

    .activity-e-time {
      font-size: .8rem;
    }
  }
}
</style>